import React, { useContext, useEffect, useState } from "react";
import MyInput from "../../../MyInput";
import { filterDataContext } from "../../../../App";
import { RemoveFilter } from "../../../../utils/func";

const AvailabilitySorting = ({
  createFilterParams,
  searchParams,
  setSearchParams,
}) => {
  const { ticketAvailabiltyInput, setTicketAvailabiltyInput } =
    useContext(filterDataContext);

  useEffect(() => {
    if (searchParams.get("ticket_Availability")) {
      setTicketAvailabiltyInput(searchParams.get("ticket_Availability"));
    }
  }, []);

  useEffect(() => {
    let checkTicket = {};
    if (ticketAvailabiltyInput.length > 0) {
      if (ticketAvailabiltyInput > 0) {
        checkTicket = { tickets_Avalability: ticketAvailabiltyInput };
        createFilterParams(checkTicket);
      }
    }
    if (
      checkTicket.tickets_Avalability === undefined &&
      ticketAvailabiltyInput.length === 0
    ) {
      RemoveParam();
    }
  }, [ticketAvailabiltyInput]);

  const RemoveParam = () => {
    searchParams.delete("ticket_Availability");
    setSearchParams(searchParams);
  };

  return (
    <div className="price_range">
      <MyInput
        inputType={"number"}
        placeholderText="Search"
        value={ticketAvailabiltyInput}
        func={setTicketAvailabiltyInput}
        min={0}
      />
    </div>
  );
};

export default AvailabilitySorting;
